jQuery($ => {
    if ($('.m-posts-search-menu')[0]) {
        $('.m-posts-search-menu__select').change(function () {
            $(this).closest('form').submit();
        });
    }
});